import { API } from "../../../utils";

export const plAndBsReportExportTypes = {
  plExcel: "pl-report",
  plCsv: "csv-pl-report",
  plPdf: "pdf-pl-report",
  bsExcel: "bs-report",
  bsCsv: "bs-report-csv",
  bsPdf: "bs-report-pdf",
};

export const getAccountList = async (params) => {
  const res = await API.get(`pl_bs_accounts`, params);
  return res.data;
};
export const getListById = async (id) => {
  const res = await API.get(`pl_bs_accounts/${id}`);
  return res.data;
};

export const getPLReport = async (payload) => {
  const res = await API.get(`pl_report`, payload);
  return res.data;
};
export const getBSReport = async (payload) => {
  const res = await API.get(`bs_report`, payload);
  return res.data;
};

export const uploadExcel = async (payload) => {
  const res = await API.post(`pl_bs_accounts`, payload);
  return res.data;
};
export const updateExcel = async (payload, id) => {
  const res = await API.post(`pl_bs_accounts/${id}`, payload);
  return res.data;
};

export const downloadReport = async (id) => {
  const res = await API.get(`pl_bs_accounts/${id}/download`, {
    responseType: "blob",
  });
  return res;
};

export const exportPlAndBsReportApi = async ({ reportType, params }) => {
  return await API.get(`exports/${reportType}`, {
    params,
    responseType: "blob",
  });
};

// account overwrite request
export const getOverwriteRequestsApi = async (params) => {
  const response = await API.get(`pl-bs-accounts/overwrite-requests`, params);
  return response.data;
};

// account overwrite history
export const getAccountOverwriteHistoriesApi = async ({ accountUploadId }) => {
  const response = await API.get(`pl-bs-accounts/${accountUploadId}/history`);
  return response.data;
};

// approve or reject overwrite request
export const approveOrRejectOverwriteRequestApi = async ({
  accountUploadId,
  action, // 2 for approval and 3 for reject
}) => {
  const response = await API.put(
    `pl_bs_accounts/${accountUploadId}/status-change/${action}`
  );
  return response.data;
};
